import './AdMentorReqStyles.css'
import React, { useEffect, useRef, useState } from 'react'
import Button from '../../../components/Button/Button';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { useNavigate } from 'react-router-dom';
import ViewAcceptRej from '../../../components/Popups/ViewAcceptRej/ViewAcceptRej';
import Reqaccprej from '../../../components/Popups/Reqaccprej/Reqaccprej';
import Congratulations from '../../../components/Popups/Congratulations/Congratulations';
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow';
import { useDispatch, useSelector } from 'react-redux';
import { acceptMentorRequest, adminData, clearState, clearUsers, getAllMentorRequests, rejectMentorRequest } from '../../../reducer/adminSlice';
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import moment from 'moment';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom';
import ErrorToast from '../../../components/Toast/ErrorToast';
import SuccessToast from '../../../components/Toast/SuccessToast';
import Skeleton from 'react-loading-skeleton';

const AdMentorRequest = () => {

    //Temporary states
    const [index, setIndex] = useState(1);
    const [selectedMentor, setSelectedMentor] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    //Popup states
    const [requestPopupToggler, setRequestPopupToggler] = useState(false);
    const [rejectPopupToggler, setRejectPopupToggler] = useState(false);
    const [acceptPopupToggler, setAcceptPopupToggler] = useState(false);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    //Search states
    const [search, setSearch] = useState("");

    //Load more states
    const [totalRequests, setTotalRequests] = useState([]);

    const { isRequestsFetching, isLoaderFetching, isSuccess, isError, errorMessage, mentorRequests } = useSelector(adminData);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleAcceptRequest = () => {
        dispatch(acceptMentorRequest(selectedMentor?.id));
    };

    const handleRejectRequest = () => {
        dispatch(rejectMentorRequest(selectedMentor?.id));
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        dispatch(getAllMentorRequests({ index: index + 1 }));
    };

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
        setTotalRequests([]);
        setIndex(1);
        dispatch(getAllMentorRequests({ search, user: "mentee" }));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setTotalRequests([]);
            setIndex(1);
            dispatch(getAllMentorRequests({ search, user: "mentee" }));
        }
    };

    useEffect(() => {
        dispatch(getAllMentorRequests({}));

        return () => {
            dispatch(clearUsers());
        }
    }, []);

    //Load more useEffect
    useEffect(() => {
        if (index === 1 && mentorRequests?.mentors?.length > 0) setTotalRequests(mentorRequests?.mentors);
        if (index !== 1 && mentorRequests?.mentors?.length > 0) setTotalRequests(prev => [...prev, ...mentorRequests?.mentors]);
        if (mentorRequests?.totalCount) setTotalCount(mentorRequests?.totalCount);
    }, [mentorRequests]);

    useEffect(() => {
        if (isSuccess) {
            setTotalRequests([]);
            setIsShowSuccess(true);
            setSuccessMessage("Success!");
            setAcceptPopupToggler(false);
            setRequestPopupToggler(false);
            setRejectPopupToggler(false);
            dispatch(getAllMentorRequests({}));
            dispatch(clearState());
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            setTotalRequests([]);
            dispatch(clearState());
        }
    }, [isError]);

    const targetRef = useRef(null);

    useEffect(() => {

        const element = document.querySelector(".CallHistoryTabledata");
        const element1 = document.querySelector(".innerdiv");

        const handleScroll = () => {
            if (targetRef.current) {
                const { top } = targetRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= windowHeight) {
                    handleLoadMore();
                }
            }
        };

        element.addEventListener('scroll', handleScroll);
        element1.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
            element1.removeEventListener('scroll', handleScroll);
        };
    }, [handleLoadMore]);

    return (
        <>
            {isLoaderFetching && <PageLoader />}
            <ErrorToast
                show={isShowError}
                setShow={() => setIsShowError(false)}
                message={errMessage}
            />
            <SuccessToast
                show={isShowSuccess}
                setShow={() => setIsShowSuccess(false)}
                message={successMessage}
            />
            <div className="callHIstoryWrap Adreqfixtable">
                <ViewAcceptRej isActive={requestPopupToggler} setIsActive={setRequestPopupToggler} mentor={selectedMentor} handleAcceptRequest={handleAcceptRequest} handleRejectRequest={handleRejectRequest} />
                <Reqaccprej isActive={rejectPopupToggler} setIsActive={setRejectPopupToggler} mentor={selectedMentor} handleRejectRequest={handleRejectRequest} />
                <Congratulations maintext='Congratulations!' isActive={acceptPopupToggler} textpass="The mentor has successfully been added." mentor={selectedMentor} />
                <div className="headingwrap flex-between">
                    <div>
                        <h2 className='heading-2 mb6'>Mentor Joining Requests</h2>
                        {<p className='text3'>Total number of requests {totalCount ?? 0}</p>}
                    </div>
                </div>

                <div className={`commonTableWrapper AdcommonWrapperforAll`}>
                    <div className="FaqUserFiltter flex-between">
                        {<SearchBar placeholder={'Search here...'} className={"searchbardesign"} value={search} onChange={handleSearchChange} onClick={handleSearch} onKeyDown={handleSearchPress} />}
                        {<div className="dropdownbtnshow" >
                            <input type='text' placeholder={`Showing ${totalRequests?.length ?? 0} out of ${totalCount}`} disabled className='disabledInput' />
                        </div>}
                    </div>

                    <div className={`CallHistoryTabledata AdMentorRequsttable mt20 fixreqtablegap`}>

                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Name</th>
                                        <th>Company</th>
                                        <th> <div className="headingtablediv">Date of Joining</div> </th>
                                        <th> <div className="headingtablediv">Program</div> </th>
                                        <th> <div className="headingtablediv">Functional focus area</div></th>
                                        <th> <div className="headingtablediv">Mentoring On</div> </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className="innerdiv">
                            <table>
                                <tbody>
                                    {totalRequests?.length > 0 ? totalRequests?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="tableBox" >
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.profileImg ? item?.profileImg : "/assets/img/User.png"} alt="" className='pointer' onClick={() => { setRequestPopupToggler(true); setSelectedMentor(item) }} />
                                                    </div>
                                                    <div className='Namedetails'>
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => { setRequestPopupToggler(true); setSelectedMentor(item) }}>{item?.firstName ? `${item?.firstName} ${item?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.profession?.designation ? item?.profession?.designation : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.profession?.company ? item?.profession?.company : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox dsblock'>
                                                    <h4>{item?.createdAt ? moment(item?.createdAt).format("DD MMMM") : "---"}</h4>
                                                    <p className='text2'>{item?.createdAt ? moment(item?.createdAt).format("dddd") : "---"}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.program?.programName ? item?.program?.programName : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.interests?.length > 0 ? item?.interests[0]?.interest : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.topics?.length > 0 ? item?.topics[0]?.Topic : "---"}</h4>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="tableBox">
                                                    <div className="designiconstool tooltipfixtop">
                                                        <span className='tooltip pointer' data-tooltip="View Details" onClick={() => { setRequestPopupToggler(true); setSelectedMentor(item) }}>
                                                            <img src="/assets/img/eye.png" alt="" />
                                                        </span>
                                                        <span className='tooltip pointer' data-tooltip="Accept" onClick={() => dispatch(acceptMentorRequest(item?.id))}>
                                                            <img src="/assets/img/icons/greentick.png" alt="" />
                                                        </span>
                                                        <span className='tooltip pointer' data-tooltip="Reject" onClick={() => { setRejectPopupToggler(true); setSelectedMentor(item) }}>
                                                            <img src="/assets/img/icons/cross.png" alt="" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : !isRequestsFetching && <DatanotFound />}
                                    {isRequestsFetching &&
                                        <>
                                            {[1, 2, 3, 4].map(item => (
                                                <tr key={item}>
                                                    <td>
                                                        <div className="tableBox" >
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"100px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"150px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox dsblock'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                            <p className='text2'>{<Skeleton width={"60px"} />}</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton enableAnimation animation={"wave"} width={"100px"} />}</h4>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="tableBox">
                                                            <div className="designiconstool">
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>}
                                </tbody>
                            </table>

                            {(!isRequestsFetching && (totalRequests?.length < mentorRequests?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef}>
                                <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                            </div>}
                        </div>

                        {/* {(!isRequestsFetching && (totalRequests?.length < mentorRequests?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef}>
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>} */}

                    </div>


                </div>
                {/* <Paginationarrow /> */}
            </div>
        </>

    )
}

export default AdMentorRequest